import { ColorTheme } from '@figma/fpl-themes';
import { color as fplColor } from '@figma/fpl-tokens/tokens.stylex';

import { Box } from '@/UI/Box/Box';
import { Flex } from '@/UI/styles';
import { useFplMigrationFlag } from '@/contexts/FplMigrationContext';

function GalleryGradientOverlay({
  isSelected = false,
  children,
  bottomOffset = 0,
}: {
  isSelected?: boolean;
  children?: React.ReactNode;
  bottomOffset?: number;
}) {
  const isFplEnabled = useFplMigrationFlag();

  const bottomGradient = isFplEnabled
    ? `linear-gradient(to top, ${fplColor.bgSecondary}, transparent)`
    : 'linear-gradient(to top, #343337D3, #6B6B7800)';
  const topGradient = isFplEnabled
    ? `linear-gradient(to bottom, ${fplColor.bgSecondary}, transparent)`
    : 'linear-gradient(to bottom, #343337D3, #6B6B7800)';

  // Media controls need the same contrast over their gradient in either app theme.
  return (
    <ColorTheme mode="dark">
      <Box
        data-testid="gradient-overlay-container"
        sx={{
          color: fplColor.text,
          position: 'absolute',
          top: 0,
          bottom: bottomOffset,
          width: '100%',
          zIndex: 1,
          overflow: 'hidden',
          pointerEvents: 'none',
          opacity: isSelected ? 1 : 0,
          transition: 'opacity 0.1s ease-in-out',
        }}
      >
        {children && <Box sx={{ pointerEvents: 'auto' }}>{children}</Box>}
        <Flex
          data-testid="bottom-gradient-overlay"
          sx={{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            height: '80px',
            background: bottomGradient,
            pointerEvents: 'none',
            filter: 'blur(30px)',
            transform: 'scale(1.8)  translateY(30px)',
            borderRadius: '2',
          }}
        />
        <Flex
          data-testid="bottom-gradient-overlay"
          sx={{
            position: 'absolute',
            top: 0,
            width: '100%',
            height: '80px',
            background: topGradient,
            pointerEvents: 'none',
            filter: 'blur(30px)',
            transform: 'scale(1.8)  translateY(-30px)',
          }}
        />
      </Box>
    </ColorTheme>
  );
}

GalleryGradientOverlay.displayName = 'GalleryGradientOverlay';

export default GalleryGradientOverlay;
